const stateMachine = {
  start: {
    key: "START",
    label: "Was ist passiert?",
    questions: [
      {
        key: "VORWURF",
        type: "radio",
        options: [
          {
            key: "SPEEDING",
            label: "Zu schnell gefahren",
          },
          {
            key: "DISTANCE",
            label: "Zu nah aufgefahren",
          },
          {
            key: "RED_LIGHT",
            label: "Rote Ampel überfahren",
          },
          {
            key: "MOBILE_PHONE",
            label: "Handy am Steuer",
          },
          {
            key: "ALCOHOL",
            label: "Alkohol / Drogen beim Fahren",
          },
        ],
      },
    ],
  },
  results: [
    {
      key: "SPEEDING",
      label: "Zu schnell gefahren",
      questions: [
        {
          key: "TYPE_OF_VEHICLE",
          type: "button",
          label: "Kraftfahrzeugart",
          options: [
            {
              key: "VEHICLE_ONLY",
              label: "PKW / Motorrad",
            },
            {
              key: "WITH_TRAILER",
              label: "PKW mit Anhänger / LKW",
            },
          ],
        },
        {
          key: "PLACE",
          type: "button",
          label: "Ort des Verstoßes",
          options: [
            {
              key: "INNER_CITY",
              label: "Innerorts",
            },
            {
              key: "OUTER_CITY",
              label: "Außerorts",
            },
          ],
        },
        {
          key: "TEMPO",
          type: "dropdown",
          label: "Tempoüberschreitung in km/h",
          conditions: [
            {
              key: "TYPE_OF_VEHICLE",
              value: "VEHICLE_ONLY",
            },
          ],
          options: [
            {
              key: "LESS_THAN_10",
              label: "Bis 10 km/h",
            },
            {
              key: "11_TO_15",
              label: "11 - 15 km/h",
            },
            {
              key: "16_TO_20",
              label: "16 - 20 km/h",
            },
            {
              key: "21_TO_25",
              label: "21 - 25 km/h",
            },
            {
              key: "26_TO_30",
              label: "26 - 30 km/h",
            },
            {
              key: "31_TO_40",
              label: "31 - 40 km/h",
            },
            {
              key: "41_TO_50",
              label: "41 - 50 km/h",
            },
            {
              key: "51_TO_60",
              label: "51 - 60 km/h",
            },
            {
              key: "61_TO_70",
              label: "61 - 70 km/h",
            },
            {
              key: "MORE_THAN_70",
              label: "Über 70 km/h",
            },
          ],
        },
        {
          key: "TEMPO_TRAILER",
          type: "dropdown",
          label: "Tempoüberschreitung in km/h",
          conditions: [
            {
              key: "TYPE_OF_VEHICLE",
              value: "WITH_TRAILER",
            },
          ],
          options: [
            {
              key: "LESS_THAN_10",
              label: "Bis 10 km/h",
            },
            {
              key: "11_TO_15",
              label: "11 - 15 km/h",
            },
            {
              key: "16_TO_20",
              label: "16 - 20 km/h",
            },
            {
              key: "21_TO_25",
              label: "21 - 25 km/h",
            },
            {
              key: "26_TO_30",
              label: "26 - 30 km/h",
            },
            {
              key: "31_TO_40",
              label: "31 - 40 km/h",
            },
            {
              key: "41_TO_50",
              label: "41 - 50 km/h",
            },
            {
              key: "51_TO_60",
              label: "51 - 60 km/h",
            },
            {
              key: "61_TO_70",
              label: "61 - 70 km/h",
            },
            {
              key: "MORE_THAN_70",
              label: "Über 70 km/h",
            },
          ],
        },
      ],
    },
    {
      key: "DISTANCE",
      label: "Zu nah aufgefahren",
      questions: [
        {
          key: "SPEED",
          type: "dropdown",
          label: "Gefahrene Geschwindigkeit in km/h",
          options: [
            {
              key: "LESS_THAN_80",
              label: "Bis 80 km/h",
            },
            {
              key: "81_TO_100",
              label: "81 - 100 km/h",
            },
            {
              key: "101_TO_130",
              label: "101 - 130 km/h",
            },
            {
              key: "MORE_THAN_130",
              label: "Über 130 km/h",
            },
          ],
        },
        {
          key: "DISTANCE_METRES",
          type: "dropdown",
          label: "Abstand in Meter: weniger als",
          conditions: [
            {
              key: "SPEED",
              value: ["81_TO_100", "101_TO_130", "MORE_THAN_130"],
            },
          ],
          options: [
            {
              key: "5_OUT_OF_10",
              label: "5/10 des halben Tachowertes",
            },
            {
              key: "4_OUT_OF_10",
              label: "4/10 des halben Tachowertes",
            },
            {
              key: "3_OUT_OF_10",
              label: "3/10 des halben Tachowertes",
            },
            {
              key: "2_OUT_OF_10",
              label: "2/10 des halben Tachowertes",
            },
            {
              key: "1_OUT_OF_10",
              label: "1/10 des halben Tachowertes",
            },
          ],
        },
      ],
    },
    {
      key: "RED_LIGHT",
      label: "Rote Ampel überfahren",
      questions: [
        {
          key: "DURATION",
          type: "button",
          label: "Wie lange war es schon rot?",
          options: [
            {
              key: "LESS_THAN_1_SECOND",
              label: "Weniger als 1 Sekunde",
            },
            {
              key: "MORE_THAN_1_SECOND",
              label: "1 Sekunde oder länger",
            },
          ],
        },
        {
          key: "DANGER",
          type: "button",
          label: "Personengefährdung",
          options: [
            {
              key: "YES",
              label: "Ja",
            },
            {
              key: "NO",
              label: "Nein",
            },
          ],
        },
      ],
    },
    {
      key: "MOBILE_PHONE",
      label: "Handy am Steuer",
      questions: [
        {
          key: "DANGER_TO_PEOPLE",
          type: "button",
          label: "Personengefährdung",
          options: [
            {
              key: "YES",
              label: "Ja",
            },
            {
              key: "NO",
              label: "Nein",
            },
          ],
        },
        {
          key: "DAMAGE",
          type: "button",
          label: "Sachbeschädigung",
          options: [
            {
              key: "YES",
              label: "Ja",
            },
            {
              key: "NO",
              label: "Nein",
            },
          ],
        },
      ],
    },
    {
      key: "ALCOHOL",
      label: "Alkohol / Drogen beim Fahren",
      questions: [
        {
          key: "TYPE",
          type: "button",
          label: "Verstoß",
          options: [
            {
              key: "ALCOHOL",
              label: "Alkohol",
            },
            {
              key: "DRUGS",
              label: "Drogen",
            },
          ],
        },
        {
          key: "MEASUREMENT_TYPE",
          type: "button",
          label: "Art der Messung",
          conditions: [
            {
              key: "TYPE",
              value: "ALCOHOL",
            },
          ],
          options: [
            {
              key: "BREATH",
              label: "Atemalkohol Messung",
            },
            {
              key: "BLOOD",
              label: "Blutalkohol Messung",
            },
          ],
        },
        {
          key: "AMOUNT_OF_ALCOHOL_BLOOD",
          type: "dropdown",
          label: "Alkoholgehalt",
          conditions: [
            {
              key: "TYPE",
              value: "ALCOHOL",
            },
            {
              key: "MEASUREMENT_TYPE",
              value: "BLOOD",
            },
          ],
          options: [
            {
              key: "SMALL",
              label: "Bis 0.5 Promille Blutalkohol",
            },
            {
              key: "MEDIUM",
              label: "0.5 bis 1.09 Promille Blutalkohol",
            },
            {
              key: "LARGE",
              label: "Ab 1.1 Promille Blutalkohol",
            },
          ],
        },
        {
          key: "AMOUNT_OF_ALCOHOL_BREATH",
          type: "dropdown",
          label: "Alkoholgehalt",
          conditions: [
            {
              key: "TYPE",
              value: "ALCOHOL",
            },
            {
              key: "MEASUREMENT_TYPE",
              value: "BREATH",
            },
          ],
          options: [
            {
              key: "SMALL",
              label: "Bis 0.25 mg/l",
            },
            {
              key: "MEDIUM",
              label: "0.25 - 0.545 mg/l",
            },
            {
              key: "LARGE",
              label: "ab 0.535 mg/l",
            },
          ],
        },
        {
          key: "CONVICTIONS_ALCOHOL_BREATH",
          type: "dropdown",
          label: "Anzahl bisheriger Alkoholverstöße",
          conditions: [
            {
              key: "TYPE",
              value: "ALCOHOL",
            },
            {
              key: "MEASUREMENT_TYPE",
              value: "BREATH",
            },
            {
              key: "AMOUNT_OF_ALCOHOL_BREATH",
              value: "MEDIUM",
            },
          ],
          options: [
            {
              key: "NONE",
              label: "Kein vorheriger Akoholverstoß",
            },
            {
              key: "ONE",
              label: "Ein vorheriger Alkoholverstoß",
            },
            {
              key: "TWO",
              label: "Zwei oder mehr vorherige Alkoholverstöße",
            },
          ],
        },
        {
          key: "CONVICTIONS_ALCOHOL_BLOOD",
          type: "dropdown",
          label: "Anzahl bisheriger Alkoholverstöße",
          conditions: [
            {
              key: "TYPE",
              value: "ALCOHOL",
            },
            {
              key: "MEASUREMENT_TYPE",
              value: "BLOOD",
            },
            {
              key: "AMOUNT_OF_ALCOHOL_BLOOD",
              value: "MEDIUM",
            },
          ],
          options: [
            {
              key: "NONE",
              label: "Kein vorheriger Akoholverstoß",
            },
            {
              key: "ONE",
              label: "Ein vorheriger Alkoholverstoß",
            },
            {
              key: "TWO",
              label: "Zwei oder mehr vorherige Alkoholverstöße",
            },
          ],
        },
        {
          key: "CONVICTIONS_AMOUNT_DRUGS",
          type: "dropdown",
          label: "Anzahl bisheriger Drogenverstöße",
          conditions: [
            {
              key: "TYPE",
              value: "DRUGS",
            },
          ],
          options: [
            {
              key: "NONE",
              label: "0",
            },
            {
              key: "ONE",
              label: "1",
            },
            {
              key: "TWO",
              label: "2",
            },
            {
              key: "MORE_THAN_TWO",
              label: "Mehr als 2",
            },
          ],
        },
      ],
    },
  ],
};

export default stateMachine;
